<div ng-controller="OrganizationGeneralController as generalCtrl">
    <c-auto-form config="generalCtrl.autoFormConfig"></c-auto-form>
</div>